import { Box } from '@skin-seoul/design-system';

interface HoverAreaProps {
  side: 'left' | 'right';
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onClick: () => void;
  expandedSection: 'left' | 'right' | null;
  hasExpanded: boolean;
}

const HoverArea = ({ side, onMouseEnter, onMouseLeave, onClick, expandedSection, hasExpanded }: HoverAreaProps) => {
  const isExpanded = expandedSection === side;
  const width = isExpanded ? '100%' : '50%';
  const left = isExpanded ? '0' : side === 'left' ? '0' : '50%';

  return (
    <Box
      position="absolute"
      top={0}
      left={left}
      width={width}
      height="100%"
      cursor={hasExpanded ? 'default' : 'pointer'}
      zIndex={2}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={hasExpanded ? undefined : onClick}
    />
  );
};

export default HoverArea;
